import { inject, Injectable } from '@angular/core';
import { HsBlazorService } from '@hsetu/core-services';

@Injectable({
  providedIn: 'root',
})
export class LicenseService {
  private readonly _serviceKey = 'kfmLicense';
  private readonly _blazorService = inject(HsBlazorService);

  public async checkLicense(): Promise<boolean> {
    const licenseResult = await this._blazorService.invokeService(
      this._serviceKey,
      'CheckLicense',
    );

    if (licenseResult) {
      const licenseValid = licenseResult as Record<string, unknown>;

      return licenseValid && licenseValid['isLicenseValid'] === true;
    }

    return false;
  }
}
